import { type SyntheticEvent } from 'react'
import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Tabs as MuiTabs,
  type TabsProps as MuiTabsProps,
} from '@mui/material'
import { Tab, type TabProps } from '../Tab'
import { type BaseProps, type PropsWithSpecificChildren } from '../../types'

export type TabsProps<V = string> = Pick<MuiTabsProps, 'slots' | 'onClick' | 'variant'> &
  BaseProps<HTMLDivElement> & {
    value: V
    onChange?: (event: SyntheticEvent<HTMLButtonElement>, value: V) => void
  } & (
    | {
        children: PropsWithSpecificChildren<TabProps>
        tabs?: never
      }
    | {
        tabs: Omit<TabProps<V>, 'onClick'>[]
        children?: never
      }
  )

/**
 * Tabs
 *
 * Demos:
 * - [Tabs](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-tabs--docs)
 *
 */

export const Tabs = <V = string,>({ tabs, children, variant = 'standard', ...props }: TabsProps<V>) => (
  <MuiTabs {...props} variant={variant} scrollButtons="auto" selectionFollowsFocus>
    {tabs ? tabs.map((tab) => <Tab {...tab} key={tab.value} />) : children}
  </MuiTabs>
)
